import React from "react";

export default function TextField({
  label,
  name,
  type = "text",
  value,
  onChange,
  placeholder = "",
  required = false,
  className = "",
  maxLength,
  error,
  showCharCount = false,
  disabled = false,
}) {
  return (
    <div className={className}>
      {label && (
        <label
          htmlFor={name}
          className="block text-sm font-medium mb-2 text-primary-dark"
        >
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}

      <input
        id={name}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        maxLength={maxLength}
        disabled={disabled}
        className={`w-full py-2.5 px-4 border rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-transparent ${
          error ? "border-red-500" : "border-gray-300"
        }`}
      />

      {/* Error message */}
      {error && <p className="text-sm text-red-500 mt-1">{error}</p>}

      {/* Character counter */}
      {showCharCount && maxLength && (
        <p className="text-xs text-gray-500 mt-1 text-right">
          {value?.length || 0}/{maxLength}
        </p>
      )}
    </div>
  );
}
